<template>
<div>
  <div class="content content-boxed">
    <!-- Information du profile -->
    <div class="row">
      <h2 class="block-title align-center">{{sectionTitle[actualLanguage]}}</h2>

      <div v-if="flagDisplayNewGraph" class="col-xs-12">

        <div class="col-sm-12 col-lg-12">
          <div id="chart">
            <apexchart type="area" height="350" :options="chartOptions" :series="chartDataSeries"></apexchart>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>
</template>


<script>

import Vue from 'vue'
import {mapState, mapActions, mapGetters} from 'vuex'

//https://apexcharts.com/docs/vue-charts/
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)


export default {
  name: 'GraphApexTimeline',
  props: ['GraphData'],
 
  /* Structure of GraphData:
  GraphData = {
    ChartTitle : {FR:'Titre Francais',EN:'English title'},
    Data : [{name: 'Series name', data: [[1324508400000, 25], [1324594800000, 32], ...]}]
  }
  */

  data() {
    return {
      actualLanguage : "FR",
      sectionTitle: {FR: 'Titre du graphique', EN: 'Graph title'},
      flagDisplayNewGraph : true,


      chartDataSeries: [{
        name: 'TBD',
        data: [[1324508400000, 34], [1324594800000, 54],[1326236400000, 43],[1326236405000, 43],[1326236406000, 53],[1326236406500, 63]],
      },
      {
        name: 'TBD',
        data: [[1324508400000, 25], [1324594800000, 32],[1326236400000, 24],[1326236405000, 36],[1326236406000, 43],[1326236406500, 62]],
      },
      ],

      chartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 350,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: 'zoom'
          }
        },
        tooltip:{
            x :{format : 'dd MMM hh:mm'}
          },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0,
        },
        title: {
          text: '',
          align: 'left'
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 70, 100]
          },
        },
        xaxis: {
            type: 'datetime'
          }
      },


    }
  },
  components: {

  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','actualBundle','parentContainer']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

  },

  mounted() {


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// GraphApexTimeLine.vue?5f094b78